<template>
  <c-modal title='Change Password' v-model='open'>
    <c-row>
      <c-col span="5"></c-col>
      <c-col>
        <c-form @submit.prevent="validateBeforeSubmit">
          <span class="form-help u-color-danger" v-show="globalError !== ''">{{globalError}}</span>
          <c-form-field>
            <c-form-field label="Old password:">
              <c-form-input name="lastPassword" type="password" v-model="lastPassword" v-validate="'required'"/>
              <span class="u-fs-12 u-color-danger" v-show="errors.has('lastPassword')">Please specify the previous password</span>
            </c-form-field>
            <c-form-field label="New password:">
              <c-form-input name="newPassword" type="password" v-model="newPassword" v-validate="'required'"/>
              <span class="u-fs-12 u-color-danger"
                    v-show="errors.has('newPassword')">Please specify the new password</span>
            </c-form-field>
            <c-form-field label="Confirm new password:">
              <c-form-input data-vv-as="newPassword" name="confirmPassword" type="password"
                            v-model="confirmPassword" v-validate="'required|confirmed:newPassword'"/>
              <span class="u-fs-12 u-color-danger" v-show="errors.has('confirmPassword')">Please confirm the new password</span>
            </c-form-field>
          </c-form-field>
        </c-form>
      </c-col>
      <c-col span="5"></c-col>
    </c-row>
    <div slot="footer">
      <c-button @click="onConfirm" type="primary">Confirm</c-button>
    </div>
  </c-modal>
</template>
<script>

  /*
  toaster component: https://alligator.io/vuejs/vue-notifications-snotify/
  */

  import axios from 'axios'

  export default {
    name: 'ChangePassword',
    data () {
      return {
        open: false,
        lastPassword: '',
        newPassword: '',
        confirmPassword: '',
        globalError: ''
      }
    },
    methods: {
      onConfirm () {
        this.validateBeforeSubmit()
      },

      show () {
        this.lastPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        this.globalError = ''

        this.open = true
      },

      validateBeforeSubmit () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            // eslint-disable-next-line
            this.performChangePassword()
          }
        })
      },

      performChangePassword () {
        axios.post(process.env.API + 'user/passwordchanges', {
          'oldPassword': this.lastPassword,
          'newPassword': this.newPassword
        }).then((response) => {
          if (response.data.hasOwnProperty('response')) {
            if (response.data.response === 'ok') {
              this.$snotify.success(
                'Password changed successfully',
                null,
                {
                  position: 'centerTop',
                  timeout: 3000,
                  showProgressBar: false
                }
              )
              this.open = false
            } else {
              this.$snotify.error(
                response.data.error,
                null,
                {
                  position: 'centerTop',
                  timeout: 3000,
                  showProgressBar: false
                }
              )
            }
          } else {
            // CM 20191229 ???
            // window.sessionStorage.setItem('token', response.data)
            this.$snotify.success(
              'Password changed successfully',
              null,
              {
                position: 'centerTop',
                timeout: 3000,
                showProgressBar: false
              }
            )
            this.open = false
          }
        }).catch((reason) => {
          console.error('Could not change password')
          this.globalError = 'Unable to change password (old password does not match?)'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue